<script setup lang="ts">
import { groupPositionsByLocation } from '@/services/careers'

const props = defineProps({
  teamName: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
  positions: {
    type: Array,
    required: false,
    default: () => [],
  },
  showTitle: {
    type: Boolean,
    required: true,
  },
})

const positionsByLocation = computed(() => {
  return groupPositionsByLocation(props.positions)
})

const locations = computed(() => {
  return Object.keys(positionsByLocation.value)
})
</script>

<template>
  <div class="CareersTeam">
    <template v-if="showTitle">
      <div class="CareersTeam_Heading">
        {{ teamName }}
      </div>
      <p v-if="description" class="CareersTeam_Description">
        {{ description }}
      </p>
    </template>
    <div
      v-if="positions.length"
      class="CareersTeam_Locations"
      :class="{
        CareersTeam_Locations_Title: showTitle,
        CareersTeam_Locations_NoTitle: !showTitle,
      }"
    >
      <CareersLocation
        v-for="location in locations"
        :key="`team-location-${teamName}-${location}`"
        :location-name="location"
        :positions="positionsByLocation[location]"
      />
    </div>
    <p v-else class="CareersTeam_NoRoles">No open roles at this time.</p>
  </div>
</template>

<style lang="scss">
.CareersTeam {
  flex-basis: 256px;
  flex-grow: 1;
  padding: 0 var(--spacing-2x);

  &_Description {
    max-width: 656px;
  }

  &_Heading {
    @include type-heading('4');
    margin-top: 0;
  }

  &_Locations {
    display: flex;
    flex-wrap: wrap;
    margin: 0;

    &_NoTitle {
      margin-top: var(--spacing-4x);
    }

    &_Title {
      margin-top: var(--spacing-8x);
    }
  }

  &_NoRoles {
    color: var(--text-color-secondary);
    font-family: var(--font-family-default-medium);
    font-weight: var(--font-weight-medium);
    margin: var(--spacing-8x) 0 var(--spacing-4x);
  }
}
</style>
